import {
  ADD_UPLOAD,
  UPDATE_UPLOAD_PROGRESS,
  SET_UPLOAD_PROCESSING,
  SET_UPLOAD_READY,
  SET_UPLOAD_ERROR,
  REMOVE_UPLOAD,
} from "./upload.type";

const initialState = {
  // Each item: { uploadId, title, contentType ('movie' | 'episode'), progress,
  // status ('uploading' | 'processing' | 'ready' | 'error'), hlsFileName, runtime, error, createdAt }
  uploads: [],
};

const uploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_UPLOAD:
      return {
        ...state,
        uploads: [action.payload, ...state.uploads],
      };

    case UPDATE_UPLOAD_PROGRESS:
      return {
        ...state,
        uploads: state.uploads.map((u) =>
          u.uploadId === action.payload.uploadId
            ? { ...u, progress: action.payload.progress }
            : u
        ),
      };

    case SET_UPLOAD_PROCESSING:
      return {
        ...state,
        uploads: state.uploads.map((u) =>
          u.uploadId === action.payload.uploadId
            ? { ...u, status: "processing", progress: 100 }
            : u
        ),
      };

    case SET_UPLOAD_READY:
      return {
        ...state,
        uploads: state.uploads.map((u) =>
          u.uploadId === action.payload.uploadId
            ? {
                ...u,
                status: "ready",
                hlsFileName: action.payload.hlsFileName,
                runtime: action.payload.runtime,
              }
            : u
        ),
      };

    case SET_UPLOAD_ERROR:
      return {
        ...state,
        uploads: state.uploads.map((u) =>
          u.uploadId === action.payload.uploadId
            ? { ...u, status: "error", error: action.payload.error }
            : u
        ),
      };

    case REMOVE_UPLOAD:
      return {
        ...state,
        uploads: state.uploads.filter((u) => u.uploadId !== action.payload.uploadId),
      };

    default:
      return state;
  }
};

export default uploadReducer;
